import type { Reducers } from "../../graph/types.ts";
import type { IdentityAggregates } from "../../types/assessment/data/identity.ts";
import type { AssessmentNodes } from "../../types/assessment/data/index.ts";
import { grantAggregate, keyAggregate, privilegeAggregate } from "./shared.ts";

//  TODO: ENG-4411 fix and add back the below once the credential aggregation is fixed to aggregate only parents to one level.
//  credentials: keyAggregate("credential"),
//  lastAuthEvent: max("credential", (n) => n.lastAuthnTime),
export const identityReducers: Reducers<AssessmentNodes, IdentityAggregates> = {
  grants: grantAggregate,
  privileges: privilegeAggregate,
  risks: keyAggregate("risk"),
};
